export default "__VITE_ASSET__DT6Vs5zw__"